import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import List from '../List.js';
import Message from '../Message/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function ListView(props) {
  const {
    className,
    pending,
    errored,
    filtered,
    emptyIcon,
    emptyMessage,
    pendingMessage,
    filteredEmptyIcon,
    filteredEmptyMessage,
    erroredEmptyIcon,
    erroredEmptyMessage,
    data,
    compactPendingMessage,
    compactEmptyMessage,
    compactAndVerticalEmptyMessage,
    messageActions,
    spacing = 'none',
    direction = 'horizontal',
    messageShown = false,
    messageIconShown = false,
    style,
    onReload,
    reverse,
    ...otherListProps
  } = props;
  const empty = !(data !== null && data !== void 0 && data.length && data.length > 0);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.listView, empty && styles.empty, pending && styles.pending, spacingToStyleMap[spacing], direction === 'vertical' && styles.vertical, reverse && styles.reverse, className),
    style: style
  }, /*#__PURE__*/React.createElement(Message, {
    empty: empty,
    errored: errored,
    pending: pending,
    filtered: filtered,
    emptyIcon: emptyIcon,
    emptyMessage: emptyMessage,
    pendingMessage: pendingMessage,
    filteredEmptyIcon: filteredEmptyIcon,
    filteredEmptyMessage: filteredEmptyMessage,
    erroredEmptyIcon: erroredEmptyIcon,
    erroredEmptyMessage: erroredEmptyMessage,
    compactPendingMessage: compactPendingMessage,
    compact: compactEmptyMessage,
    compactAndVertical: compactAndVerticalEmptyMessage,
    messageHidden: !messageShown,
    messageIconHidden: !messageIconShown,
    onReload: onReload,
    actions: messageActions
  }), !errored && /*#__PURE__*/React.createElement(List, _extends({
    data: data,
    spacing: spacing
  }, otherListProps)));
}

var ListView$1 = genericMemo(ListView);

export { ListView$1 as default };
//# sourceMappingURL=index.js.map
